import { Pipe } from "@angular/core";

@Pipe({
    name: "phonePipe"
})
export class phonePipe {
    /* transform(rawNum: any) {
        let phoneNumber = '';
        if (rawNum) {
            const firstStr = rawNum.slice(0, 3);
            const secondStr = rawNum.slice(3, 6);
            const thirdStr = rawNum.slice(6, 10);
            phoneNumber = `${firstStr}-${secondStr}-${thirdStr}`;
        }
        return phoneNumber 
    } */

    transform(rawNum: any) {
        let phoneNumber = '';
        if (rawNum) {
            const firstStr = rawNum.slice(0, 2);
            const secondStr = rawNum.slice(2, 6);
            const thirdStr = rawNum.slice(6, 10);
            phoneNumber = `${firstStr}-${secondStr}-${thirdStr}`;
        }
        return phoneNumber 
    }
}

